export const initialActions = {
  setState({ commit }, newState) {
    commit('SET_STATE', newState);
  },
};

export const initialMutations = {
  SET_STATE(state, { key, payload }) {
    state[key] = payload;
  },
};
